<template>
<div class="chapter">
<div class="inner_page">
<h1 class="GFP_Part_H1">part one</h1>
<p class="GFP_Center">...............................</p>
<h2 class="GFP_Time_H2">before</h2>
<p class="GFP_Quote">I have loved, O Lord, the beauty of thy house<br/>and the place where dwelleth thy glory.</p>
<p class="GFP_Quote_Attribution">Psalm 26:8</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?8d1ce5f4